import { mapGetters, mapMutations } from 'vuex';

export default {
    data() {
        return {
            visible: false, // set the modal visibility
            title: '', // title of the modal,
            meterName: '',
            onConfirm: {}, // callback
            component: null, // component to pass to the modal
            isFormDirty: false, // check if the form has been touched
            showConfirmBox: false, // confirmation if user wants to save changes
        };
    },
    computed: {
        ...mapGetters([
            'teamMainLang',
        ]),
    },
    watch: {
        visible(value) {
            this.setEscListener(value);
        },
    },
    methods: {
        ...mapMutations([
            'setSelectedLang',
        ]),
        // Hide the modal
        hide() {
            if (!this.isFormDirty) this.destroyModal();
            else this.showConfirmBox = true;
        },
        destroyModal() {
            this.showConfirmBox = false;
            this.visible = false;
            this.component = null; // we always instanciating back the component. Prevents previously dirtied inputs
            this.disableNext = true;
            this.resetData();
            this.setSelectedLang(this.teamMainLang);
        },
        setEscListener(visible) {
            if (visible) {
                document.addEventListener('keyup', this.handleEscape, true);
            } else {
                document.removeEventListener('keyup', this.handleEscape, true);
            }
        },
        handleEscape(event) {
            if (event.key === 'Escape') {
                if (this.showConfirmBox) {
                    this.showConfirmBox = false;
                } else {
                    this.hide();
                }
            }
        },
    },
};
